// Calls the /api/chat serverless function instead of the Gemini API directly,
// so the API key stays server-side and never ships in the client bundle.
export const sendMessageToGemini = async (userMessage, history = []) => {
    try {
        const response = await fetch("/api/chat", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ message: userMessage, history }),
        });

        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            return body.error || `Connection Error: request failed with status ${response.status}.`;
        }

        const data = await response.json();
        return data.text || "Sorry, I couldn't generate a response.";
    } catch (error) {
        console.error("Error calling chat API:", error);
        return `Connection Error: ${error.message || "Unknown error"}.`;
    }
};
